// get_nationality
export const GET_NATIONALITY = 'get_nationality';
export const GET_NATIONALITY_SUCCESSFUL = 'get_nationality_successfull';
export const GET_NATIONALITY_FAILED = 'get_nationality_failed';

// create_nationality
export const CREATE_NATIONALITY = 'create_nationality';
export const CREATE_NATIONALITY_SUCCESSFUL = 'create_nationality_successfull';
export const CREATE_NATIONALITY_FAILED = 'create_nationality_failed';

// update_nationality
export const UPDATE_NATIONALITY = 'update_nationality';
export const UPDATE_NATIONALITY_SUCCESSFUL = 'update_nationality_successfull';
export const UPDATE_NATIONALITY_FAILED = 'update_nationality_failed';

// delete_nationality
export const DELETE_NATIONALITY = 'delete_nationality';
export const DELETE_NATIONALITY_SUCCESSFUL = 'delete_nationality_successfull';
export const DELETE_NATIONALITY_FAILED = 'delete_nationality_failed';
